import React from "react";
import { Text, View } from "react-native";

const getInitials = (firstName?: string, lastName?: string): string => {
  const firstInitial = firstName?.charAt(0)?.toUpperCase() ?? "";
  const lastInitial = lastName?.charAt(0)?.toUpperCase() ?? "";
  return `${firstInitial}${lastInitial}`;
};

type UserAvatarProps = Readonly<{
  firstName?: string;
  lastName?: string;
  size?: number;
}>;

const UserAvatar = ({ firstName, lastName, size = 32 }: UserAvatarProps) => {
  const initials = getInitials(firstName, lastName);

  return (
    <View
      style={{ width: size, height: size, borderRadius: size / 2 }}
      className="bg-primary items-center justify-center"
    >
      <Text
        className="text-white font-semibold"
        // Scaled with the circle rather than a fixed `text-xs`: the same
        // component renders at 100px on the profile header, where 12px
        // initials read as a typo inside an otherwise empty disc. Mirrors
        // BlocksAvatar's placeholder so both fallbacks look alike.
        style={{ fontSize: Math.max(12, Math.round(size * 0.42)) }}
        numberOfLines={1}
      >
        {initials}
      </Text>
    </View>
  );
};

export default UserAvatar;
